import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Container, Header } from "semantic-ui-react";
import { setTitle, setMetaDescription } from '../../util';
import { connect } from "react-redux";

class About extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    document.querySelector('body').classList.add('bg--black');
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('bg--black');
  }

  render() {
    return (
      <section className="space about ui segment inverted vertical">
        <Header as="h1" className="display-1 itc-mdbold text-uc" textAlign='center'>About Us</Header>
        <Container text>
          <p>FibreStream keeps it simple and our local team takes pride in showing you just how easy surfing the Internet can be. We believe that we only deserve your business if we can continue to keep you happy. That's why we strive to treat every interaction like we're helping a friend.</p>
          <p>Many thanks to all our loyal subscribers for taking us this far. Our team is excited to continue redefining Internet connectivity for Canadians.</p>
        </Container>
      </section>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = state => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(About)
)


// WEBPACK FOOTER //
// ./src/components/about/About.js